import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_BY_BRAND, ORDER_ASCENDING, NEGOTIATION_PHASE } from '../Utils/Constants';
const sControllerEndpoint = 'NegotiationLots';


export class NegotiationLotAPI {

  getNegotiationLots(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, state = NEGOTIATION_PHASE, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (state)
      params.state = state;
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetLotsList', { params });
  }

  getLotById(L1Id) {
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetL1ById?L1Id=' + L1Id);
  }

  createNegotiationLot(dto) {
    return axios.post(getBackendURL() + sControllerEndpoint + '/CreateL1', dto);
  }

  editNegotiationLot(dto) {
    return axios.put(getBackendURL() + sControllerEndpoint + '/UpdateL1', dto);
  }

  cancelNegotiationLot(L1Id, cancelObs) {
    return axios.post(getBackendURL() + sControllerEndpoint + '/CancelL1?L1Id=' + L1Id + '&obsCancelamento=' + cancelObs);
  }

  duplicateNegotiationLot(L1Id) {
    return axios.put(getBackendURL() + sControllerEndpoint + '/CloneL1?L1Id=' + L1Id);
  }

  finishNegotiationLot(L1Id) {
    return axios.put(getBackendURL() + sControllerEndpoint + '/FinishL1Negotiation?L1Id=' + L1Id);
  }

}

export default NegotiationLotAPI


// WEBPACK FOOTER //
// ./src/API/NegotiationLotsAPI.js